class catalogHelper {

    constructor() {
        this.app = app;
    }

    search(el) {
        el.addEventListener('submit', (e) => {
            e.preventDefault();
            let searchTerm = e.target[0].value;
            if (searchTerm) {
                this.loadCatalogState({ searchTerm: searchTerm });
            } else {
                this.loadCatalogState({ searchTerm: "" });
            }
        });
    }
    universalBanner(el) {
        const banner = document.getElementById("universal-banner");
        const cookieConsent = app.cookies.get("cookie_consent_user_accepted");
        const bannerDismissed = app.cookies.get("universal_banner_dismissed");

        if (cookieConsent) {
            $('#universal-banner').on('close.bs.alert', function () {
                app.cookies.set("universal_banner_dismissed", true, 4);
            });
            // if (!bannerDismissed) {
                banner.classList.add('show');
            // }
        }

    }
    loadCatalogState(newStateValues) {
        let savedState = JSON.parse(localStorage.getItem("tooling-catalog-state"));
        const initialState = {
            paged: 1,
            order: "",
            orderby: "",
            searchTerm: "",
            selectedFilters: {},
            filterOptions: {},
            requests: [],
            loaderMessage: "Loading Catalog",
            showLoader: true,
            isSubmitting: false,
            formDrawerOpen: false
        }

        if (savedState) {
            let newState = Object.assign(savedState, newStateValues);
            localStorage.setItem("tooling-catalog-state", JSON.stringify(newState));
        } else {
            let newState = Object.assign(initialState, newStateValues);
            console.log(newState);
            localStorage.setItem("tooling-catalog-state", JSON.stringify(newState));
        }
        window.location.href = "/cts/catalog/search";
    }
}


window.app.add('catalog', new catalogHelper());